<template>
  <BaseForm
    :title="formTitle"
    :formData="customerRateData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue'; // Ensure the path is correct
import axios from 'axios'; // Ensure axios is imported

export default {
  components: {
    BaseForm
  },
  props: {
    customerRateId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      customerRateData: {
        cust_id: '',
        crop_id: '',
        description: '',
        rate: '',
        at_moisture: ''
      },
      fields: [
        { model: 'cust_id', label: 'Customer', required: true, type: 'select', optionsUrl: '/api/v1/customer/customers/', labelField: 'name' },
        { model: 'crop_id', label: 'Crop', required: true, type: 'select', optionsUrl: '/api/v1/crop/crops/', labelField: 'crop' },
        { model: 'description', label: 'Description', type: 'text' },
        { model: 'rate', label: 'Rate ($)', required: true, type: 'number' },
        { model: 'at_moisture', label: 'At Moisture (%)', required: true, type: 'number' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.customerRateId ? `Edit Customer Rate` : 'Add Customer Rate';
    },
    submitUrl() {
      return this.customerRateId ? `/api/v1/customer_rate/customer_rates/${this.customerRateId}/` : '/api/v1/customer_rate/customer_rates/';
    },
    method() {
      return this.customerRateId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.customerRateId) {
      this.loadCustomerRateData();
    }
  },
  methods: {
    loadCustomerRateData() {
      axios.get(`/api/v1/customer_rate/customer_rates/${this.customerRateId}/`).then(response => {
        this.customerRateData = { ...response.data, cust_id: response.data.cust_id.id, crop_id: response.data.crop_id.id };
      }).catch(error => {
        console.error("Failed to load customer rate data", error);
      });
    },
    handleSuccess() {
      // Handle success notification
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Customer Rate saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError() {
      // Handle error notification
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the customer rate!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
